import { BaseApiService } from "./BaseApiService";
import { PREFIX } from "utils/Const";
import {
  IApiResponse,
  IDeliveryOrder,
  IDeliveryOrderDetail,
  IGetByIdRequest,
  IGetDeliveryOrderDetail,
  IPaginateApiResponse,
  IPaginationRequest,
  IUpdateDeliveryOrderRequest,
} from "model";
const prefix = PREFIX.receive;

const GET_ALL_DELIVERY_ORDER_URL = `${prefix}/get-delivery-ticket`;
const URL_GET_DELIVERY_ORDER_BY_ID = `${prefix}/get-delivery-ticket-by-id`;
const GET_DELIVERY_ORDER_DETAIL_URL = `${prefix}/get-delivery-ticket-detail`;
const URL_UPDATE_DELIVERY_ORDER = `${prefix}/update-delivery-ticket`;

class PrepareApiService extends BaseApiService {
  public getAllDeliveryOrders = (request: IPaginationRequest) =>
    this.get<IPaginateApiResponse<IDeliveryOrder[]>>(
      GET_ALL_DELIVERY_ORDER_URL,
      {
        params: request,
      }
    );
  public getDeliveryOrderById = (request: IGetByIdRequest) =>
    this.get<IApiResponse<IDeliveryOrder>>(URL_GET_DELIVERY_ORDER_BY_ID, {
      params: request,
    });
  public getDeliveryOrderDetail = (request: IGetDeliveryOrderDetail) =>
    this.get<IPaginateApiResponse<IDeliveryOrderDetail[]>>(
      GET_DELIVERY_ORDER_DETAIL_URL,
      {
        params: request,
      }
    );
  public updateDeliveryOrder = (request: IUpdateDeliveryOrderRequest) =>
    this.put<IUpdateDeliveryOrderRequest, IApiResponse<IDeliveryOrder>>(
      URL_UPDATE_DELIVERY_ORDER,
      request
    );
}

export default new PrepareApiService(true);
